import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary] Caught error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          background: '#0D1117',
          fontFamily: 'system-ui, sans-serif',
          padding: '24px',
        }}>
          <div style={{
            width: '100%',
            maxWidth: '380px',
            padding: '32px 28px',
            borderRadius: '16px',
            backgroundColor: 'rgba(20, 24, 32, 0.95)',
            borderBottom: '3px solid #F5A623',
            boxShadow: '0 0 0 1px rgba(255,255,255,0.05), 0 30px 80px rgba(0,0,0,0.9)',
            textAlign: 'center',
          }}>
            <div style={{
              width: '56px',
              height: '56px',
              margin: '0 auto 20px',
              borderRadius: '50%',
              background: 'rgba(245, 166, 35, 0.12)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                <path d="M12 9v4m0 4h.01M10.29 3.86 1.82 18a1 1 0 0 0 .86 1.5h18.64a1 1 0 0 0 .86-1.5L13.71 3.86a1 1 0 0 0-1.72 0Z"
                  stroke="#F5A623" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <h2 style={{ fontSize: '19px', fontWeight: 700, color: '#E8EDF3', margin: '0 0 8px' }}>
              Something went wrong
            </h2>
            <p style={{ color: '#9ca3af', fontSize: '13px', lineHeight: 1.5, margin: '0 0 24px' }}>
              An unexpected error occurred. Please reload the page to continue.
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{
                width: '100%',
                padding: '12px',
                background: 'linear-gradient(135deg, #F5A623, #E08E00)',
                color: '#0D1117',
                border: 'none',
                borderRadius: '10px',
                cursor: 'pointer',
                fontWeight: 700,
                fontSize: '14px',
                boxShadow: '0 6px 18px rgba(245, 166, 35, 0.35)',
              }}
            >
              Reload page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
